<template>
  <div class="rating-field" :class="{'rating-field--error': !isValid}">
    <label class="rating-field__label">{{label}}</label>
    <v-rating
      class="rating-field__stars"
      :value="value"
      @input="onInput"
      color="yellow darken-3"
      background-color="grey darken-1"
      empty-icon="star_border"
      half-increments
      hover />

    <div class="rating-field__error-message">請評分</div>
  </div>
</template>

<script>
export default {
  inject: ['form'],

  data() {
    return {
      isValid: true
    };
  },

  props: {
    value: {
      default: 0
    },
    label: {
      type: String,
      default: ''
    }
  },

  watch: {
    value() {
      this.validate();
    }
  },

  // register self to from's listener list.
  created() {
    this.form && this.form.register(this);
  },

  // unregister self from from's listener list.
  beforeDestroy() {
    this.form && this.form.unregister(this);
  },

  methods: {
    validate() {
      if (this.value === 0) {
        this.isValid = false;
      } else {
        this.isValid = true;
      }
      return this.isValid;
    },

    async reset() {
      this.$emit('input', 0);
      await this.$nextTick();
      this.isValid = true;
    },

    onInput(v) {
      this.$emit('input', v);
    }
  }
};
</script>

<style lang="stylus" scoped>

.rating-field--error {
  .rating-field__label {
    color: $error-color;
  }

  .rating-field__error-message {
    display: block;
  }
}

.rating-field__error-message {
  font-size: 12px;
  color: $error-color;
  display: none;
}

.rating-field__label {
  font-size: 16px;
  color: rgba(0,0,0,.54);
}

.rating-field__stars {
  position: relative;
  left: -8px;
  margin-top: 4px;
}
</style>
